if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.currentVariant = null;
      this.cartesian = null;
      this.areAllSelectionsMade = false;
      this.sizeMapping = !!this.dataset.sizeMapping;
    }
    
    connectedCallback() {
      this.locale = this.dataset.locale == 'false' ? false : this.dataset.locale   
      this.cartesian = JSON.parse(this.querySelector('template[data-cartesian]')?.content.textContent ?? '[]');
      this.atcButton = this.querySelector('[data-action="add-to-cart"]');
      this.notifyButton = this.querySelector('#attn-waitlist-trigger');
      this.stickyATC = this.querySelector('[data-sticky-atc] button');
      this.form = this.querySelector(`form[action="${this.locale ? `/${this.locale}` : `` }/cart/add"]`);      
      
      this.isCart();
      if (!this.cartesian) return;
      this.calculateAvailabilityOfPartiallyMatchingVariants();
     
      if (this.closest('custom-modal')) {
        window.dispatchEvent(new CustomEvent('productForm:quickView', { 
          detail: {
            productTitle: `${this.closest('custom-modal').querySelector('[data-title]')?.innerText}`,
            styleNumber: `${this.closest('custom-modal').querySelector('[data-sku]')?.innerText}`,
            viewType: "Quick view"
          }
        }));
      }
            
      let optionsPersisted = true;
      window.selectedOptionsToPersist?.forEach((option, i) => {       
        const optionSelector = this.querySelector(`[data-action="option-choice"][data-option="${option}"]`);
        
        if (optionSelector) {
          optionSelector.checked = true;
          this.querySelector(`[data-option-selection="${optionSelector.dataset.position}"]`).innerText = option;
        } else optionsPersisted = false;
        
        if (!optionsPersisted) return;
        this.currentVariant = this.cartesian[this.getCurrentOptionSet()] || null;
        if (this.currentVariant) {
          window.dispatchEvent(new CustomEvent('productForm:skuChange', { detail: { skuCode: this.currentVariant.variant_json.sku }}));
          this.updatePriceDisplay();
        }
        this.calculateAvailability(); 
      });
      
      this.addEventListener('change', e => {
        const clickedElement = e.target.closest('[data-action]');
        if (!clickedElement) return;
        
        const {
          action,
          position,
          option
        } = clickedElement.dataset;
                
        switch (action) {
          case 'option-choice':
            this.querySelector(`[data-option-selection="${position}"]`).innerText = option;
            this.currentVariant = this.cartesian[this.getCurrentOptionSet(position, option).toString()];
            this.updateOptionChoice(position, option);
          break;
        }
      });
      this.addEventListener(`cart:cartAddItem`, e => {
        e.target.closest('custom-modal')?.close();
      })
      this.addEventListener('submit', e => {
        if (!e.target.closest('form[action="/cart/add"]') || this.currentVariant) {
          if (!e.target.querySelector(`input[name="limit"]`)) {
            e.target.closest('custom-modal')?.close();
          }
          return;
        }
        
        e.stopImmediatePropagation;
        e.stopPropagation();
        e.preventDefault();
        
        this.classList.add('selection-needed');        
      });
      
      function isInViewport(element) {
        var rect = element.getBoundingClientRect();
        var html = document.documentElement;
        return (
          rect.top > window.scrollY ||
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= (window.innerHeight || html.clientHeight) &&
          rect.right <= (window.innerWidth || html.clientWidth)
        );
      }
      
      window.addEventListener('scroll', () => {
        this.classList.toggle('in-view', isInViewport(this));
      });

      const url_params = new URLSearchParams(window.location.search);

      if (!this.currentVariant && url_params.has('variant')) {
        const variant_id = Number(url_params.get('variant'));
        const variant_key = Object.keys(this.cartesian).find(key => this.cartesian[key].variant_json.id === variant_id);
        this.currentVariant = this.cartesian[variant_key];

        const size_radio_group = this.querySelector('#size-radiogroup');
        const size_option = size_radio_group.querySelector(`input[type="radio"][value="${this.currentVariant.variant_json.option1}"]`);

        if (size_option) size_option.checked = true;

        const {
          position,
          option
        } = size_option.dataset;

        this.updateOptionChoice(position, option);
      }
    }

    updateOptionChoice(position, option) {
      if (this.currentVariant) window.selectedOptionsToPersist = [...this.getCurrentOptionSet(position, option)];

      this.calculateAvailability();
      this.updatePriceDisplay();

      window.dispatchEvent(new CustomEvent('productForm:sizeChange', { detail: { sizeCode: `${this.getCurrentOptionSet().map(x => x)}` }}));

      if (this.currentVariant) {
        window.dispatchEvent(new CustomEvent('productForm:skuChange', { detail: { skuCode: this.currentVariant.variant_json.sku }}));

        if (this.currentVariant.is_plus) {
          window.dispatchEvent(new CustomEvent('productForm:plusSizeSelectedChanged'));
        }
      }

      if (typeof PayPalSDK !== 'undefined') {
        PayPalSDK.Messages({
          amount: this.currentVariant.variant_json.price/100,
          pageType: "product-details",
        }).render('.pp-message');
        document.querySelectorAll('[data-pp-message]').forEach((paypal, i) => { paypal.classList.add('hidden')})
      }
    }
    
    calculateAvailability() {
      const isCartEdit = this.closest('sparky-shuffle').dataset.cartItemKey || false;
      this.areAllSelectionsMade = !this.querySelector(`[data-selector-group]:not(:has([data-action="option-choice"]:checked))`);
      
      if (this.sizeMapping) {
        const hiddenOptionInput = this.querySelector('input[name="properties[Size]"]');
        if (hiddenOptionInput) {
          hiddenOptionInput.value = this.getCurrentOptionSet();
        } else {
          this.querySelector('form')?.insertAdjacentHTML('beforeend', `
            <input data-form-property type="hidden" name="properties[Size]" value="${this.getCurrentOptionSet()}" />
          `);
        }
      }
      
      if (!this.areAllSelectionsMade) {
        const unselected_group = this.querySelector(`[data-selector-group]:not(:has([data-action="option-choice"]:checked))`);
        const unselected_group_name = unselected_group.parentElement.querySelector('[data-option-selection]').innerHTML;
        this.atcButton.innerHTML = unselected_group_name;

        this.calculateAvailabilityOfPartiallyMatchingVariants();
        return;
      } else {
        //----Fix for Rebuy ATC
        this.atcButton.classList.remove('pointer-events-none');
        this.atcButton.innerHTML = isCartEdit ? "Update" : "Add to Bag";
        if (this.stickyATC) this.stickyATC.innerHTML = "Add to Bag";
        //this.notifyButton.classList.toggle('disabled', !this.currentVariant);
        //--End fix for Rebuy ATC
        this.stickyATC?.setAttribute('form', this.form.getAttribute('id'));
        this.stickyATC?.removeAttribute('onClick');
        
        this.querySelectorAll('[data-action="option-choice"]').forEach((optionChoice) => {         
          const { position, option } = optionChoice.dataset;
          const thisVariant = this.getMatchingVariant(position, option);
          if (!this.areAllSelectionsMade && optionChoice.closest(`[data-selector-group]:has([data-action="option-choice"]:checked)`)) return;
          optionChoice.nextElementSibling.classList.toggle('unavailable', !thisVariant?.variant_json.available);
        }); 
      }
      
      if (this.currentVariant?.variant_json.available) {
        this.querySelector('[type="submit"][data-action="add-to-cart"]')?.removeAttribute('disabled');
      } else this.querySelector('[type="submit"][data-action="add-to-cart"]')?.setAttribute('disabled', true);
            
      this.classList.toggle('selection-needed', false);  

      if (!this.currentVariant) return;
      this.querySelector('select[name="id"]').value = this.currentVariant.variant_json.id;
    }
    
    updatePriceDisplay() {
      if (!this.currentVariant) return;
      const priceDisplays = this.closest('sparky-shuffle')?.querySelectorAll('[data-price]');      
      priceDisplays.forEach((el) => {
        if (Number(this.currentVariant.variant_json.compare_at_price) > Number(this.currentVariant.variant_json.price)) {
          const saleMessaging = el.querySelector('[data-sale-messaging]');
          el.innerHTML = `
          <span class="line-through">
            ${this.dataset.currencySymbol}${Number(this.currentVariant.variant_json.compare_at_price / 100)
              .toFixed((this.currentVariant.variant_json.compare_at_price % 100) ? 2 : 0)}
          </span>
          ${saleMessaging ? `<span data-sale-messaging class="text-torchRed -mr-1">${saleMessaging.innerHTML}</span>` : ''}
          <span class="text-torchRed font-medium">
            ${this.dataset.currencySymbol}${Number(this.currentVariant.variant_json.price / 100)
              .toFixed((this.currentVariant.variant_json.price % 100) ? 2 : 0)}
          </span>
        `;
        return;
        }
        
        el.innerHTML = `<span>${this.dataset.currencySymbol}${Number(this.currentVariant.variant_json.price / 100)
          .toFixed((this.currentVariant.variant_json.price % 100) ? 2 : 0)}</span>`;
      });
    }
    
    getCurrentOptionSet(position, option) {
      let thisOptionSet;
        thisOptionSet = [...this.querySelectorAll('[data-action="option-choice"][data-option]:checked')].map(({ value }) => value);
      if (position && option) {
        const optionIndex = Number(position) - 1;
        thisOptionSet[optionIndex] = option;
      }
      return thisOptionSet;
    }
    
    calculateAvailabilityOfPartiallyMatchingVariants() {
      const selectedOptionValues = this.getCurrentOptionSet();
      const unselectedOptionElements = this.querySelectorAll('[data-selector-group]:not(:has([data-action="option-choice"]:checked)) [data-action="option-choice"]');
      const allCartesianKeys = Object.keys(this.cartesian);
    
      unselectedOptionElements.forEach((input) => {
        const cartesianSet = [input.value, ...selectedOptionValues];
        const matchingKeys = allCartesianKeys.filter((key) => {
          const splitKey = key.split(',');
          return cartesianSet.every(value => splitKey.includes(value));
        });
        const isAvailable = matchingKeys.some(key => this.cartesian[key].variant_json.available);
    
        input.nextElementSibling.classList.toggle('unavailable', !isAvailable);
      });
    }
    
    getMatchingVariant(position, option) {
      const optionIndex = Number(position) - 1;
      let thisOptionSet = this.getCurrentOptionSet();
      thisOptionSet[optionIndex] = option;
            
      return this.cartesian[thisOptionSet.toString()]
    }

    isCart(){
      const isCartEdit = this.closest('sparky-shuffle').dataset.cartItemKey || false;
      if (!isCartEdit) return;
      
      const mobileSelects = this.querySelectorAll('[data-action=option-choice-dropdown]');
      mobileSelects.forEach(select => {
        let selectedLabel = select.getAttribute('id');
        this.querySelector(`label[for="${selectedLabel}"] [data-option-value]`).innerHTML = `: ${select.value}`;
      });
      
      
      const quantity = this.closest('sparky-shuffle').dataset.cartQty || 1;
      this.atcButton.innerHTML = '<span>Update</span>';
      this.atcButton.addEventListener('click', e => {
        e.preventDefault();
        this.currentVariant ?  this.editCartItem(isCartEdit, this.currentVariant.variant_json.id, quantity) : this.classList.add('selection-needed');  
      });
    }

    editCartItem(oldItemKey, newItemId, newItemQuantity) {
      const removeItemURL = '/cart/change.js';
      const removeItemParams = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: oldItemKey,
          quantity: 0
        })
      };
      
      fetch(removeItemURL, removeItemParams)
        .then(response => response.json())
        .then(() => {
          const addItemURL = '/cart/add.js';
          const propertyInputs = this.querySelectorAll('[data-form-property]');
          const properties = {};
        
          if (propertyInputs) {
            for (let input of propertyInputs) {
              const key = input.getAttribute('name').match(/\[(.*?)\]/)[1];
              const val = input.value;

              properties[key] = val;
            }
          }
          
          const addItemParams = {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: newItemId,
              quantity: newItemQuantity,
              properties
            })
          };
          
          return fetch(addItemURL, addItemParams);
        })
        .then(response => response.json())
        .then(() => {
          document.querySelectorAll('[data-cart-section]').forEach((sectionWrapper) => {
            const sectionId = sectionWrapper.dataset.cartSection;
            const loader = document.querySelector(`template[data-loader="${sectionId}"]`)?.cloneNode(true);
            const sectionInnerHTML = sectionWrapper.innerHTML;
            sectionWrapper.innerHTML = `
              <intersection-loader 
                data-url="/cart"
                data-section-id="${sectionId}"
                class="${sectionWrapper.classList}"
              >${loader ? loader.innerHTML : sectionInnerHTML}</intersection-loader>
            `;
          });
        })
        .then(() => {
          const modal = document.querySelector('custom-modal');
          modal.close();
        })
        .catch(error => {
          console.error('Error updating cart:', error);
          alert(`Error updating the cart: ${error}`);
        });
      }
  }
  
  customElements.define('product-form', ProductForm);
}
